export const manageIndexes = {
  filterIndexes: 'Pokaż indeksy',
  all: 'Wszystkie',
  withIndex: 'Z indeksami',
  withoutIndex: 'Bez indeksów',
  option: '[opcja]',
  dynamic: 'Generowana dynamicznie na podstawie indeksu wybranej opcji',
} as const
